import { ApiService } from '@services/ApiService'
import { BaseStore } from '@stores/baseStore'
import { action } from 'mobx'

const defaultState = {}

class Store extends BaseStore {
  constructor() {
    super()

    this.initStore(defaultState, {
      fetchData: action,
    })
  }

  fetchData = async id => {
    try {
      const res = await ApiService.RepaymentInvoice.InvoicePrint(id)
      return res.data
    } catch (error) {
      throw error
    }
  }

  printInvoiceSummary = async id => {
    try {
      const res = await ApiService.RepaymentInvoice.InvoiceSummaryPrint(id)
      return res.data
    } catch (error) {
      throw error
    }
  }

  print = async (filters = {}) => {
    try {
      const res = await ApiService.RepaymentInvoice.OutStandingStatementPrint(
        filters
      )
      return res.data
    } catch (error) {
      throw error
    }
  }
  printAccruedInterestStatement = async (filters = {}) => {
    try {
      const res =
        await ApiService.RepaymentInvoice.AccruedInterestStatementPrint(filters)
      return res.data
    } catch (error) {
      throw error
    }
  }
}

export default new Store()
